<app-bom-details>
  <ng-template appBomDetailsTitle>
    <h1 mat-dialog-title>
      {{ this.data.itemName }}
    </h1>
    <mat-list *ngIf="!loading" class="tw-flex tw-justify-center tw-mb-4">
      <a mat-icon-button [href]="url" target="_blank" [disabled]="!url">
        <mat-icon>description</mat-icon>
      </a>
    </mat-list>
  </ng-template>
  <ng-template appBomDetailsExtraData>
    <div *ngIf="destinationName" class="tw-flex tw-items-center tw-pl-4">
      <h3 class="tw-font-bold tw-m-0 tw-pr-3">Destino:</h3>
      <p class="tw-m-0">{{ destinationName }}</p>
    </div>
  </ng-template>
</app-bom-details>
